



















import Vue from 'vue';
import { mapState } from 'vuex';
export default Vue.extend({
    data() {
        return {
            fieldList: [
                {
                    field: 'x',
                    mapper: '-',
                    description: '类目',
                },
                {
                    field: 'y',
                    mapper: '-',
                    description: '值',
                },
                {
                    field: 's',
                    mapper: '-',
                    description: '系列',
                }
            ]
        }
    },
    computed: {
        ...mapState({
            partSelection: (state: any) => state.screen.editor.partSelection,
        }),
        /**
         * 被选中的part数组
         */
        selectGroup(): Model.Part[] {
            return this.partSelection.selectGroup;
        },
        /**
         * 当前选中的part
         * 取得该part的数据格式
         */
        curSelectPart(): Model.Part {
            const { length } = this.selectGroup
            return length === 1 ? this.selectGroup[0] : {}
        },
    }
})
